export const dateConstants = {
	displayDateFormat: 'DD-MM-YYYY',
	displayDateTimeFormat: 'DD-MM-YYYY HH:mm',
	backendDateFormat: 'YYYY-MM-DD',
};
